import { useParams } from "react-router";
import { WhoCanUsePanel } from "@/components/journey/WhoCanUsePanel";
import { AdminPageHeader } from "@/components/shell/AdminPage";
import { useAccountWorkspace } from "@/lib/account-workspace";

/**
 * 旅程设置 · 成员权限（settings/members）
 * 从账户成员勾选谁能使用本品牌客户旅程（非独立花名册）。
 */
export default function JourneySettingsPage() {
  const { brandId } = useParams();
  const { accountId, brands } = useAccountWorkspace();
  const brand = brands.find((item) => String(item.id) === brandId);

  return (
    <div className="space-y-6">
      <AdminPageHeader
        title="成员权限"
        description={
          brand
            ? `谁能使用「${brand.name}」的客户旅程。只能从账户成员勾选，不能单独邀请。`
            : "谁能使用客户旅程。只能从账户成员勾选，不能单独邀请。"
        }
      />

      {accountId && brandId ? (
        <WhoCanUsePanel
          accountId={accountId}
          brandId={brandId}
          product="journey"
          productName="客户旅程"
          brandName={brand?.name}
          hideHeader
        />
      ) : null}
    </div>
  );
}
